<template>
    <div class="deviceAnalysis">
        <div class="centerStructure">
            <section>
                <div class="item firstItem">
                    <div class="center">
                        <h1 class="h1">采集器</h1>
                        <div class="fontbox">
                            <ul>
                                <li>
                                    <span>总数<span class="vb">总数</span></span>
                                    <span class="font20">{{obj1.total}}</span>
                                </li>
                                <li>
                                    <span>本年新增</span>
                                    <span class="font20">{{obj1.yCount}}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span>本月新增</span>
                                    <span class="font20">{{obj1.mCount}}</span>
                                </li>
                                <li>
                                    <span>去年新增</span>
                                    <span class="font20">{{obj1.lyCount}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="item firstItem">
                    <div class="center">
                        <h1 class="h2">户表</h1>
                        <div class="fontbox">
                            <ul>
                                <li>
                                    <span>总数<span class="vb">总数</span></span>
                                    <span class="font20">{{obj2.total}}</span>
                                </li>
                                <li>
                                    <span>本年新增</span>
                                    <span class="font20">{{obj2.yCount}}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span>本月新增</span>
                                    <span class="font20">{{obj2.mCount}}</span>
                                </li>
                                <li>
                                    <span>去年新增</span>
                                    <span class="font20">{{obj2.lyCount}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="item firstItem">
                    <div class="center">
                        <h1 class="h3">大用户</h1>
                        <div class="fontbox">
                            <ul>
                                <li>
                                    <span>总数<span class="vb">总数</span></span>
                                    <span class="font20">{{obj3.total}}</span>
                                </li>
                                <li>
                                    <span>本年新增</span>
                                    <span class="font20">{{obj3.yCount}}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span>本月新增</span>
                                    <span class="font20">{{obj3.mCount}}</span>
                                </li>
                                <li>
                                    <span>去年新增</span>
                                    <span class="font20">{{obj3.lyCount}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="item firstItem">
                    <div class="center">
                        <h1 class="h4">考核表</h1>
                        <div class="fontbox">
                            <ul>
                                <li>
                                    <span>总数<span class="vb">总数</span></span>
                                    <span class="font20">{{obj4.total}}</span>
                                </li>
                                <li>
                                    <span>本年新增</span>
                                    <span class="font20">{{obj4.yCount}}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span>本月新增</span>
                                    <span class="font20">{{obj4.mCount}}</span>
                                </li>
                                <li>
                                    <span>去年新增</span>
                                    <span class="font20">{{obj4.lyCount}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="item firstItem">
                    <div class="center">
                        <h1 class="h5">压力计</h1>
                        <div class="fontbox">
                            <ul>
                                <li>
                                    <span>总数<span class="vb">总数</span></span>
                                    <span class="font20">{{obj5.total}}</span>
                                </li>
                                <li>
                                    <span>本年新增</span>
                                    <span class="font20">{{obj5.yCount}}</span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span>本月新增</span>
                                    <span class="font20">{{obj5.mCount}}</span>
                                </li>
                                <li>
                                    <span>去年新增</span>
                                    <span class="font20">{{obj5.lyCount}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="item thirdItem">
                    <div class="lintit"><i></i><span>设备增长趋势</span></div>
                    <ul class="button-groups">
                        <li :class="[actIdx1===index?'active':'']" v-for="(item,index) in btnArr1" :key="item"
                            @click="jmDailyChange($event,index)">{{item}}
                        </li>
                    </ul>
                    <div class="barBox" id="growthTrend"></div>
                </div>
                <div class="item thirdItem">
                    <div class="lintit"><i></i><span>设备管径统计</span></div>
                    <ul class="button-groups">
                        <li :class="[actIdx2===index?'active':'']" v-for="(item,index) in btnArr2" :key="item"
                            @click="fjmDailyChange($event,index)">{{item}}
                        </li>
                    </ul>
                    <div class="barBox" id="diameterStatistical"></div>
                </div>
            </section>
            <section class="lastone">
                <div class="item tablebox">
                    <div class="lintit"><i></i><span>客户设备统计</span></div>
                    <el-table
                        :data="tableData"
                        border
                        ref="table"
                        width="100%"
                        max-height="845">
                        <el-table-column
                            :resizable="false"
                            align="center"
                            type="index"
                            width="50">
                        </el-table-column>
                        <template v-for="item in tableTitle">
                            <el-table-column 
                                header-align="center"
                                :align="item.align" 
                                :key="item.prop" 
                                :label="item.label"
                                :prop="item.prop"
                                :width="item.width"
                                show-overflow-tooltip>
                            </el-table-column>
                        </template>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 50 ,100]"
                        :page-size="pageSize"
                        :total="pagetotal"
                        layout="total, sizes, prev, pager, next">
                    </el-pagination>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    let echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie');
    require('echarts/lib/chart/line');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/grid');
    require('echarts/lib/chart/gauge');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/title');
    require('zrender/lib/svg/svg');
    import echartsThemeSet from "@/config/echartsTheme/echartsTheme.js"
    import {mapGetters} from 'vuex'
    import {$http} from '@/config/api/axios'
    import {Mixins} from '@/config/mixins/mixins'
    import {formateDate} from '@/config/validate/common'

    export default {
        name: 'deviceAnalysis',
        mixins: [Mixins],
        data() {
            return {
                obj1:{},
                obj2:{},
                obj3:{},
                obj4:{},
                obj5:{},
                btnArr1: ['月', '年'],
                btnArr2: ['结算表', '考核表'],
                actIdx1: 0,
                actIdx2: 0,
                echartsTheme: localStorage.getItem('echartsTheme'),
                myChartsObj: {
                    growthTrend: {
                        instance: '',
                        id: 'growthTrend',
                        option: {
                            dataZoom: {type: "inside"},
                            tooltip: {
                                trigger: 'axis', 
                                transitionDuration: 0
                            },
                            grid: {
                                top: '20%',
                                bottom: '15%',
                                left: '4%',
                                right: '4%',
                                containLabel: false,
                            },
                            xAxis: {
                                type: 'category',
                                data: [],
                                axisLabel: {
                                    // rotate: 45
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: '单位：台',
                                axisLabel: {
                                    formatter: function (item) {
                                        if (item >= 10000) {
                                            let i = item / 10000;
                                            return `${i}万`;
                                        } else {
                                            return item;
                                        }
                                    }
                                }
                            }],
                            legend: {
                                data: ['户表', '大用户','考核表']
                            },
                            series: [
                                {
                                    name: '户表',
                                    type: 'bar',
                                    barMaxWidth: 70,
                                    barGap: 0,
                                    data: [],
                                },
                                {
                                    name: '大用户',
                                    type: 'bar',
                                    barMaxWidth: 70,
                                    data: [],
                                },
                                {
                                    name: '考核表',
                                    type: 'bar',
                                    barMaxWidth: 70,
                                    data: [],
                                },
                            ]
                        }
                    },
                    diameterStatistical: {
                        instance: '',
                        id: 'diameterStatistical',
                        option: {
                            dataZoom: {type: "inside"},
                            tooltip: {
                                trigger: 'axis', 
                                transitionDuration: 0
                            },
                            grid: {
                                top: '20%',
                                bottom: '15%',
                                left: '4%',
                                right: '4%',
                                containLabel: false,
                            },
                            xAxis: {
                                type: 'category',
                                data: [],
                                axisLabel: {
                                    // rotate: 45
                                }
                            },
                            yAxis: [{
                                type: 'value',
                                name: '单位(台)',
                                axisLabel: {
                                    formatter: function (item) {
                                        if (item >= 10000) {
                                            let i = item / 10000;
                                            return `${i}万`;
                                        } else {
                                            return item;
                                        }
                                    }
                                }
                            }],
                            legend: {
                                data: ['居民', '大用户']
                            },
                            series: [
                                {
                                    name: '居民',
                                    type: 'bar',
                                    barMaxWidth: 70,
                                    barGap: 0,
                                    data: [],
                                    itemStyle:{
                                        normal:{
                                            color:"#2ec7c9"
                                        }
                                    }
                                },
                                {
                                    name: '大用户',
                                    type: 'bar',
                                    barMaxWidth: 70,
                                    data: [],
                                    itemStyle:{
                                        normal:{
                                            color:"#ffb980"
                                        }
                                    }
                                },
                            ]
                        }
                    }
                },
                resizeYH: {}, // 缓存图表resize
                apiLoading1: true,
                apiLoading2: true,
                apiLoading3: true,
                apiLoading4: true,
                tableTitle:[
                    {prop:"cusName", label:'客户名称', width:'', align:'center'},
                    {prop:"creatTime", label:'创建日期', width:'', align:'center'},
                    {prop:"expireDate", label:'到期日期', width:'', align:'center'},
                    {prop:"resCount", label:'户表数量', width:'', align:'right'},
                    {prop:"unResCount", label:'大户表数量', width:'', align:'right'},
                    {prop:"checkCount", label:'考核表数量', width:'', align:'right'},
                    {prop:"houseOverCount", label:'户表余量', width:'', align:'right'},
                    {prop:"bigOverCount", label:'大表余量', width:'', align:'right'},
                ],
                tableData:[
                    {cusName:111,creatTime:'123'},
                    {cusName:111,},
                ],
                currentPage:1,
                pageSize:20,
                pagetotal:0,
            }
        },
        computed: {
            ...mapGetters('Home', [
                'globalTheme',
            ]),
            loadingShow() {
                let flag;
                if (this.apiLoading1 && this.apiLoading2 && this.apiLoading3 && this.apiLoading4) {
                    flag = 'hide';
                } else {
                    flag = 'show';
                }
                return flag;
            }
        },
        watch: {
            globalTheme(val) {
                if (this.echartsTheme !== this.globalTheme) { //切换至当前组件时，如果主题已经变化，重新初始化主题色
                    this.myChartsObj = echartsThemeSet(this.myChartsObj);
                    this.echartsTheme = this.globalTheme
                }
            },
            loadingShow(loading) {
                loading === 'show' ? this.selfLoadingOpen('.deviceAnalysis') : this.selfLoadingClose();
            }
        },
        methods: {
            handleSizeChange(pagesize){
                this.pageSize = pagesize;
                this.handleCurrentChange(1);
            },
            handleCurrentChange(currentPage){
                this.currentPage = currentPage;
                this.getTableData();
            },
            jmDailyChange(e, index) {
                switch (index) {
                    case 0:
                        this.getChart1(0)
                        break;
                    case 1:
                        this.getChart1(1)
                        break;
                }
                let tg = e.target;
                let tgp = e.target.parentElement;
                let lists = Array.from(tgp.querySelectorAll('li'));
                this.actIdx1 = lists.indexOf(tg);
            },
            fjmDailyChange(e, index) {
                switch (index) {
                    case 0:
                        this.getChart2(0)
                        break;
                    case 1:
                        this.getChart2(1)
                        break;
                }
                let tg = e.target;
                let tgp = e.target.parentElement;
                let lists = Array.from(tgp.querySelectorAll('li'));
                this.actIdx2 = lists.indexOf(tg);
            },
            getChart1(dateFlag = 0){ // 设备增长趋势
                this.apiLoading2 = false
                $http('get', "basic/deviceAnalysis/getDeviceGrowthTrend",{dateFlag}).then((res) => {
                    this.apiLoading2 = true
                    let option = this.myChartsObj.growthTrend.option;
                    option.xAxis.data = [];
                    option.series[0].data = [];
                    option.series[1].data = [];
                    option.series[2].data = [];
                    if (res.status === "SUCCESS") {
                        if(!!res.data){
                            res.data.forEach((item) => {
                                option.xAxis.data.push(item.date)
                                option.series[0].data.push(item.resCount)
                                option.series[1].data.push(item.unResCount)
                                option.series[2].data.push(item.checkCount)
                            })
                        }
                    } else {
                        this.msgerror(res.message);
                    }
                    this.myChartsObj.growthTrend.instance.setOption(option);
                })
            },
            getChart2(deviceFlag = 0){ // 查询设备管径  0-结算表  1-考核表
                this.apiLoading3 = false
                $http('get', "basic/deviceAnalysis/getDeviceCaliberStatistics",{deviceFlag}).then((res) => {
                    this.apiLoading3 = true
                    let option = this.myChartsObj.diameterStatistical.option;
                    option.xAxis.data = [];
                    option.series[0].data = [];
                    option.series[1].data = [];
                    if (res.status === "SUCCESS") {
                        if(!!res.data){
                            if(deviceFlag == 0){
                                option.legend.show = true;
                                res.data.forEach((item) => {
                                    option.xAxis.data.push(item.diameter)
                                    option.series[0].data.push(item.resCount)
                                    option.series[1].data.push(item.unResCount)
                                    option.series[0].name = '居民';
                                })
                            }else{
                                option.legend.show = false;
                                res.data.forEach((item) => {
                                    option.xAxis.data.push(item.diameterName)
                                    option.series[0].data.push(item.checkCount)
                                    option.series[0].name = '考核表';
                                })
                            }
                        }
                    } else {
                        this.msgerror(res.message);
                    }
                    this.myChartsObj.diameterStatistical.instance.setOption(option);
                })
            },
            getTableData(pageNumber){
                let params = {};
                params.pageSize = this.pageSize;
                params.pageNumber = this.currentPage;
                this.apiLoading4 = false;
                $http('get', "basic/deviceAnalysis/getCustomerDeviceStatistics",params).then((res) => {
                    this.apiLoading4 = true
                    if (res.status === "SUCCESS") {
                        if(!!res.data){
                            this.pagetotal = res.count;
                            this.tableData = Object.freeze(res.data)
                        }
                    } else {
                        this.tableData = [];
                        this.currentPage = 1;
                        this.msgerror(res.message);
                    }
                })
            },
            getFirstData(){
                this.apiLoading1 = false
                $http('get', "basic/deviceAnalysis/getMeterBaseData").then((res) => {
                    this.apiLoading1 = true
                    if (res.status === "SUCCESS") {
                        if(!!res.data){
                            this.obj1 = res.data.colList[0];
                            this.obj2 = res.data.res[0];
                            this.obj3 = res.data.unRes[0];
                            this.obj4 = res.data.check[0];
                            this.obj5 = res.data.preList[0];
                        }
                    } else {
                        this.msgerror(res.message);
                    }
                })
            },

            initEcharts(id) {
                this.myChartsObj[id].instance = echarts.init(document.getElementById(id), this.echartsTheme);
                this.myChartsObj[id].instance.setOption(this.myChartsObj[id].option)
                this.resizeYH[id] = this.debounce(this.myChartsObj[id].instance.resize);
            },
            bindResize() {
                window.addEventListener("resize", () => {
                    if (this.$route.path.includes('/deviceAnalysis')) {
                        this.resizeYH['growthTrend']();
                        this.resizeYH['diameterStatistical']();
                    }
                });
            },
        },
        created() {
            this.getFirstData()
            this.getTableData()
            this.$nextTick(() => {
                Object.keys(this.myChartsObj).forEach(key => {
                    this.initEcharts(key)
                })
                this.bindResize();
                this.getChart1();
                this.getChart2();
            })
        },
        activated() {
            this.$nextTick(()=>{
                this.resizeYH['growthTrend']();
                this.resizeYH['diameterStatistical']();
            })
        }
    }
</script>

<style lang="less">
.deviceAnalysis {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    display: flex;
    .centerStructure {
        padding: 0;
        overflow: auto;
        background: #f6f4fc !important;
        box-shadow: none;
        section {
            width: 100%;
            display: flex;
            margin-bottom: 10px;
            &:last-child {
                margin: 0;
            }
            .item {
                border-radius: 4px;
                box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
                margin-right: 10px;
                background: #fff;

                &:last-child {
                    margin: 0px;
                }
            }
            .firstItem {
                flex: 1;
                height: 165px;
                display: flex;
                .center {
                    margin: auto;
                    margin-top: 20px;
                    h1{
                        font-size: 20px;
                    }
                    .h1{
                        color: #a29afb;
                    }
                    .h2{
                        color: #5ab1ef;
                    }
                    .h3{
                        color: #edafda;
                    }
                    .h4{
                        color: #2ec7c9;
                    }
                    .h5{
                        color: #ffb980;
                    }
                    ul{
                        li{
                            span{
                                line-height: 40px;
                                font-size: 16px;
                            }
                            span.font20{
                                margin-left: 10px;
                                font-size: 20px;
                                font-weight: bold;
                                vertical-align: -2px;
                            }
                        }
                        &:first-child{
                            margin-right: 40px;
                        }
                    }
                    .fontbox{
                        display: flex;
                        .vb{
                            visibility: hidden;
                        }
                    }
                }
            }
            .thirdItem {
                flex: 1;
                min-height: 323px;
                height: calc(100vh - 613px);
                padding: 20px;
            }
            .lintit {
                margin: 0;
            }
            .button-groups {
                float: right;
                position: relative;
                z-index: 9;
            }
            .barBox {
                width: 100%;
                height: 270px;
                > div {
                    &:first-child {
                        width: 100% !important;
                    }
                }
            }
            .tablebox{
                padding: 20px;
                width: 100%;
                .lintit {
                    margin-bottom: 10px;
                }
            }
        }
        .lastone{
            min-height: 324px;
        }
    }
    .alertChart{
        width: 100%;
        height: 500px;
    }
    .ft16 {
        font-size: 16px;
    }
    .marB5 {
        margin-bottom: 5px;
    }
}
</style>
